export const months = {
  "2019": [
    { start: 1546315200, end: 1548993599 },
    { start: 1548993600, end: 1551412799 },
    { start: 1551412800, end: 1554091199 },
    { start: 1554091200, end: 1556683199 },
    { start: 1556683200, end: 1559361599 },
    { start: 1559361600, end: 1561953599 },
    { start: 1561953600, end: 1564631999 },
    { start: 1564632000, end: 1567310399 },
    { start: 1567310400, end: 1569902399 },
    { start: 1569902400, end: 1572580799 },
    { start: 1572580800, end: 1575172799 },
    { start: 1575172800, end: 1577851199 }
  ],
  "2020": [
    { start: 1577851200, end: 1580529599 },
    { start: 1580529600, end: 1583035199 },
    { start: 1583035200, end: 1585713599 },
    { start: 1585713600, end: 1588305599 },
    { start: 1588305600, end: 1590983999 },
    { start: 1590984000, end: 1593575999 },
    { start: 1593576000, end: 1596254399 },
    { start: 1596254400, end: 1598932799 },
    { start: 1598932800, end: 1601524799 },
    { start: 1601524800, end: 1604203199 },
    { start: 1604203200, end: 1606795199 },
    { start: 1606795200, end: 1609473599 }
  ],
  "2021": [
    { start: 1609473600, end: 1612151999 },
    { start: 1612152000, end: 1614571199 },
    { start: 1614571200, end: 1617249599 },
    { start: 1617249600, end: 1619841599 },
    { start: 1619841600, end: 1622519999 },
    { start: 1622520000, end: 1625111999 },
    { start: 1625112000, end: 1627790399 },
    { start: 1627790400, end: 1630468799 },
    { start: 1630468800, end: 1633060799 },
    { start: 1633060800, end: 1635739199 },
    { start: 1635739200, end: 1638331199 },
    { start: 1638331200, end: 1641009599 }
  ]
}

export const monthString = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
];

export const YEARS = {
  "2019": [
    {
      start: "2019-01-01 00:00:00",
      end: "2019-01-06 23:59:58",
    },
    {
      start: "2019-01-07 00:00:00",
      end: "2019-01-13 23:59:58",
    },
    {
      start: "2019-01-14 00:00:00",
      end: "2019-01-20 23:59:58",
    },
    {
      start: "2019-01-21 00:00:00",
      end: "2019-01-27 23:59:58",
    },
    {
      start: "2019-01-28 00:00:00",
      end: "2019-02-03 23:59:58",
    },
    {
      start: "2019-02-04 00:00:00",
      end: "2019-02-10 23:59:58",
    },
    {
      start: "2019-02-11 00:00:00",
      end: "2019-02-17 23:59:58",
    },
    {
      start: "2019-02-18 00:00:00",
      end: "2019-02-24 23:59:58",
    },
    {
      start: "2019-02-25 00:00:00",
      end: "2019-03-03 23:59:58",
    },
    {
      start: "2019-03-04 00:00:00",
      end: "2019-03-10 23:59:58",
    },
    {
      start: "2019-03-11 00:00:00",
      end: "2019-03-17 23:59:58",
    },
    {
      start: "2019-03-18 00:00:00",
      end: "2019-03-24 23:59:58",
    },
    {
      start: "2019-03-25 00:00:00",
      end: "2019-03-31 23:59:58",
    },
    {
      start: "2019-04-01 00:00:00",
      end: "2019-04-07 23:59:58",
    },
    {
      start: "2019-04-08 00:00:00",
      end: "2019-04-14 23:59:58",
    },
    {
      start: "2019-04-15 00:00:00",
      end: "2019-04-21 23:59:58",
    },
    {
      start: "2019-04-22 00:00:00",
      end: "2019-04-28 23:59:58",
    },
    {
      start: "2019-04-29 00:00:00",
      end: "2019-05-05 23:59:58",
    },
    {
      start: "2019-05-06 00:00:00",
      end: "2019-05-12 23:59:58",
    },
    {
      start: "2019-05-13 00:00:00",
      end: "2019-05-19 23:59:58",
    },
    {
      start: "2019-05-20 00:00:00",
      end: "2019-05-26 23:59:58",
    },
    {
      start: "2019-05-27 00:00:00",
      end: "2019-06-02 23:59:58",
    },
    {
      start: "2019-06-03 00:00:00",
      end: "2019-06-09 23:59:58",
    },
    {
      start: "2019-06-10 00:00:00",
      end: "2019-06-16 23:59:58",
    },
    {
      start: "2019-06-17 00:00:00",
      end: "2019-06-23 23:59:58",
    },
    {
      start: "2019-06-24 00:00:00",
      end: "2019-06-30 23:59:58",
    },
    {
      start: "2019-07-01 00:00:00",
      end: "2019-07-07 23:59:58",
    },
    {
      start: "2019-07-08 00:00:00",
      end: "2019-07-14 23:59:58",
    },
    {
      start: "2019-07-15 00:00:00",
      end: "2019-07-21 23:59:58",
    },
    {
      start: "2019-07-22 00:00:00",
      end: "2019-07-28 23:59:58",
    },
    {
      start: "2019-07-29 00:00:00",
      end: "2019-08-04 23:59:58",
    },
    {
      start: "2019-08-05 00:00:00",
      end: "2019-08-11 23:59:58",
    },
    {
      start: "2019-08-12 00:00:00",
      end: "2019-08-18 23:59:58",
    },
    {
      start: "2019-08-19 00:00:00",
      end: "2019-08-25 23:59:58",
    },
    {
      start: "2019-08-26 00:00:00",
      end: "2019-09-01 23:59:58",
    },
    {
      start: "2019-09-02 00:00:00",
      end: "2019-09-08 23:59:58",
    },
    {
      start: "2019-09-09 00:00:00",
      end: "2019-09-15 23:59:58",
    },
    {
      start: "2019-09-16 00:00:00",
      end: "2019-09-22 23:59:58",
    },
    {
      start: "2019-09-23 00:00:00",
      end: "2019-09-29 23:59:58",
    },
    {
      start: "2019-09-30 00:00:00",
      end: "2019-10-06 23:59:58",
    },
    {
      start: "2019-10-07 00:00:00",
      end: "2019-10-13 23:59:58",
    },
    {
      start: "2019-10-14 00:00:00",
      end: "2019-10-20 23:59:58",
    },
    {
      start: "2019-10-21 00:00:00",
      end: "2019-10-27 23:59:58",
    },
    {
      start: "2019-10-28 00:00:00",
      end: "2019-11-03 23:59:58",
    },
    {
      start: "2019-11-04 00:00:00",
      end: "2019-11-10 23:59:58",
    },
    {
      start: "2019-11-11 00:00:00",
      end: "2019-11-17 23:59:58",
    },
    {
      start: "2019-11-18 00:00:00",
      end: "2019-11-24 23:59:58",
    },
    {
      start: "2019-11-25 00:00:00",
      end: "2019-12-01 23:59:58",
    },
    {
      start: "2019-12-02 00:00:00",
      end: "2019-12-08 23:59:58",
    },
    {
      start: "2019-12-09 00:00:00",
      end: "2019-12-15 23:59:58",
    },
    {
      start: "2019-12-16 00:00:00",
      end: "2019-12-22 23:59:58",
    },
    {
      start: "2019-12-23 00:00:00",
      end: "2019-12-29 23:59:58",
    },
    {
      start: "2019-12-30 00:00:00",
      end: "2019-12-31 23:59:58",
    }
  ],
  "2020": [
    {
      start: "2020-01-01 00:00:00",
      end: "2020-01-05 23:59:58",
    },
    {
      start: "2020-01-06 00:00:00",
      end: "2020-01-12 23:59:58",
    },
    {
      start: "2020-01-13 00:00:00",
      end: "2020-01-19 23:59:58",
    },
    {
      start: "2020-01-20 00:00:00",
      end: "2020-01-26 23:59:58",
    },
    {
      start: "2020-01-27 00:00:00",
      end: "2020-02-02 23:59:58",
    },
    {
      start: "2020-02-03 00:00:00",
      end: "2020-02-09 23:59:58",
    },
    {
      start: "2020-02-10 00:00:00",
      end: "2020-02-16 23:59:58",
    },
    {
      start: "2020-02-17 00:00:00",
      end: "2020-02-23 23:59:58",
    },
    {
      start: "2020-02-24 00:00:00",
      end: "2020-03-01 23:59:58",
    },
    {
      start: "2020-03-02 00:00:00",
      end: "2020-03-08 23:59:58",
    },
    {
      start: "2020-03-09 00:00:00",
      end: "2020-03-15 23:59:58",
    },
    {
      start: "2020-03-16 00:00:00",
      end: "2020-03-22 23:59:58",
    },
    {
      start: "2020-03-23 00:00:00",
      end: "2020-03-29 23:59:58",
    },
    {
      start: "2020-04-06 00:00:00",
      end: "2020-04-12 23:59:58",
    },
    {
      start: "2020-04-13 00:00:00",
      end: "2020-04-19 23:59:58",
    },
    {
      start: "2020-04-20 00:00:00",
      end: "2020-04-26 23:59:58",
    },
    {
      start: "2020-04-27 00:00:00",
      end: "2020-05-03 23:59:58",
    },
    {
      start: "2020-05-04 00:00:00",
      end: "2020-05-10 23:59:58",
    },
    {
      start: "2020-05-11 00:00:00",
      end: "2020-05-17 23:59:58",
    },
    {
      start: "2020-05-18 00:00:00",
      end: "2020-05-24 23:59:58",
    },
    {
      start: "2020-05-25 00:00:00",
      end: "2020-05-31 23:59:58",
    },
    {
      start: "2020-05-01 00:00:00",
      end: "2020-06-07 23:59:58",
    },
    {
      start: "2020-06-08 00:00:00",
      end: "2020-06-14 23:59:58",
    },
    {
      start: "2020-06-15 00:00:00",
      end: "2020-06-21 23:59:58",
    },
    {
      start: "2020-06-22 00:00:00",
      end: "2020-06-28 23:59:58",
    },
    {
      start: "2020-06-29 00:00:00",
      end: "2020-07-05 23:59:58",
    },
    {
      start: "2020-07-06 00:00:00",
      end: "2020-07-12 23:59:58",
    },
    {
      start: "2020-07-13 00:00:00",
      end: "2020-07-19 23:59:58",
    },
    {
      start: "2020-07-20 00:00:00",
      end: "2020-07-26 23:59:58",
    },
    {
      start: "2020-07-27 00:00:00",
      end: "2020-08-02 23:59:58",
    },
    {
      start: "2020-08-03 00:00:00",
      end: "2020-08-09 23:59:58",
    },
    {
      start: "2020-08-10 00:00:00",
      end: "2020-08-16 23:59:58",
    },
    {
      start: "2020-08-17 00:00:00",
      end: "2020-08-23 23:59:58",
    },
    {
      start: "2020-08-24 00:00:00",
      end: "2020-08-30 23:59:58",
    },
    {
      start: "2020-08-31 00:00:00",
      end: "2020-09-06 23:59:58",
    },
    {
      start: "2020-09-07 00:00:00",
      end: "2020-09-13 23:59:58",
    },
    {
      start: "2020-09-14 00:00:00",
      end: "2020-09-20 23:59:58",
    },
    {
      start: "2020-09-21 00:00:00",
      end: "2020-09-27 23:59:58",
    },
    {
      start: "2020-09-28 00:00:00",
      end: "2020-10-04 23:59:58",
    },
    {
      start: "2020-10-05 00:00:00",
      end: "2020-10-11 23:59:58",
    },
    {
      start: "2020-10-12 00:00:00",
      end: "2020-10-18 23:59:58",
    },
    {
      start: "2020-10-19 00:00:00",
      end: "2020-10-25 23:59:58",
    },
    {
      start: "2020-10-26 00:00:00",
      end: "2020-11-01 23:59:58",
    },
    {
      start: "2020-11-02 00:00:00",
      end: "2020-11-08 23:59:58",
    },
    {
      start: "2020-11-09 00:00:00",
      end: "2020-11-15 23:59:58",
    },
    {
      start: "2020-11-16 00:00:00",
      end: "2020-11-22 23:59:58",
    },
    {
      start: "2020-11-23 00:00:00",
      end: "2020-11-29 23:59:58",
    },
    {
      start: "2020-11-30 00:00:00",
      end: "2020-12-06 23:59:58",
    },
    {
      start: "2020-12-07 00:00:00",
      end: "2020-12-13 23:59:58",
    },
    {
      start: "2020-12-14 00:00:00",
      end: "2020-12-20 23:59:58",
    },
    {
      start: "2020-12-21 00:00:00",
      end: "2020-12-27 23:59:58",
    },
    {
      start: "2020-12-28 00:00:00",
      end: "2020-12-31 23:59:58",
    }
  ],
  "2021": [
    {
      start: "2021-01-01 00:00:00",
      end: "2021-01-03 23:59:58",
    },
    {
      start: "2021-01-04 00:00:00",
      end: "2021-01-10 23:59:58",
    },
    {
      start: "2021-01-11 00:00:00",
      end: "2021-01-17 23:59:58",
    },
    {
      start: "2021-01-18 00:00:00",
      end: "2021-01-24 23:59:58",
    },
    {
      start: "2021-01-25 00:00:00",
      end: "2021-01-31 23:59:58",
    },
    {
      start: "2021-02-01 00:00:00",
      end: "2021-02-07 23:59:58",
    },
    {
      start: "2021-02-08 00:00:00",
      end: "2021-02-14 23:59:58",
    },
    {
      start: "2021-02-15 00:00:00",
      end: "2021-02-21 23:59:58",
    },
    {
      start: "2021-02-22 00:00:00",
      end: "2021-02-28 23:59:58",
    },
    {
      start: "2021-02-29 00:00:00",
      end: "2021-03-07 23:59:58",
    },
    {
      start: "2021-03-08 00:00:00",
      end: "2021-03-14 23:59:58",
    },
    {
      start: "2021-03-15 00:00:00",
      end: "2021-03-21 23:59:58",
    },
    {
      start: "2021-03-22 00:00:00",
      end: "2021-03-28 23:59:58",
    },
    {
      start: "2021-04-05 00:00:00",
      end: "2021-04-11 23:59:58",
    },
    {
      start: "2021-04-12 00:00:00",
      end: "2021-04-18 23:59:58",
    },
    {
      start: "2021-04-19 00:00:00",
      end: "2021-04-25 23:59:58",
    },
    {
      start: "2021-04-26 00:00:00",
      end: "2021-05-02 23:59:58",
    },
    {
      start: "2021-05-03 00:00:00",
      end: "2021-05-09 23:59:58",
    },
    {
      start: "2021-05-10 00:00:00",
      end: "2021-05-16 23:59:58",
    },
    {
      start: "2021-05-17 00:00:00",
      end: "2021-05-23 23:59:58",
    },
    {
      start: "2021-05-24 00:00:00",
      end: "2021-05-30 23:59:58",
    },
    {
      start: "2021-05-31 00:00:00",
      end: "2021-06-06 23:59:58",
    },
    {
      start: "2021-06-07 00:00:00",
      end: "2021-06-13 23:59:58",
    },
    {
      start: "2021-06-14 00:00:00",
      end: "2021-06-20 23:59:58",
    },
    {
      start: "2021-06-21 00:00:00",
      end: "2021-06-27 23:59:58",
    },
    {
      start: "2021-06-28 00:00:00",
      end: "2021-07-04 23:59:58",
    },
    {
      start: "2021-07-05 00:00:00",
      end: "2021-07-11 23:59:58",
    },
    {
      start: "2021-07-12 00:00:00",
      end: "2021-07-18 23:59:58",
    },
    {
      start: "2021-07-19 00:00:00",
      end: "2021-07-25 23:59:58",
    },
    {
      start: "2021-07-26 00:00:00",
      end: "2021-08-01 23:59:58",
    },
    {
      start: "2021-08-02 00:00:00",
      end: "2021-08-08 23:59:58",
    },
    {
      start: "2021-08-09 00:00:00",
      end: "2021-08-15 23:59:58",
    },
    {
      start: "2021-08-16 00:00:00",
      end: "2021-08-22 23:59:58",
    },
    {
      start: "2021-08-23 00:00:00",
      end: "2021-08-29 23:59:58",
    },
    {
      start: "2021-08-30 00:00:00",
      end: "2021-09-05 23:59:58",
    },
    {
      start: "2021-09-06 00:00:00",
      end: "2021-09-12 23:59:58",
    },
    {
      start: "2021-09-13 00:00:00",
      end: "2021-09-19 23:59:58",
    },
    {
      start: "2021-09-20 00:00:00",
      end: "2021-09-26 23:59:58",
    },
    {
      start: "2021-09-27 00:00:00",
      end: "2021-10-03 23:59:58",
    },
    {
      start: "2021-10-04 00:00:00",
      end: "2021-10-10 23:59:58",
    },
    {
      start: "2021-10-11 00:00:00",
      end: "2021-10-17 23:59:58",
    },
    {
      start: "2021-10-18 00:00:00",
      end: "2021-10-24 23:59:58",
    },
    {
      start: "2021-10-25 00:00:00",
      end: "2021-10-31 23:59:58",
    },
    {
      start: "2021-11-01 00:00:00",
      end: "2021-11-07 23:59:58",
    },
    {
      start: "2021-11-08 00:00:00",
      end: "2021-11-14 23:59:58",
    },
    {
      start: "2021-11-15 00:00:00",
      end: "2021-11-21 23:59:58",
    },
    {
      start: "2021-11-22 00:00:00",
      end: "2021-11-28 23:59:58",
    },
    {
      start: "2021-11-29 00:00:00",
      end: "2021-12-05 23:59:58",
    },
    {
      start: "2021-12-06 00:00:00",
      end: "2021-12-12 23:59:58",
    },
    {
      start: "2021-12-13 00:00:00",
      end: "2021-12-19 23:59:58",
    },
    {
      start: "2021-12-20 00:00:00",
      end: "2021-12-26 23:59:58",
    },
    {
      start: "2021-12-27 00:00:00",
      end: "2021-12-31 23:59:58",
    }
  ]
};